import { api } from '@/common/api';
import qs from 'qs';
import Vue from 'vue';
import localReferences from '@/helpers/localReferences';

const initialCurrentDeal = {
    id: null,
    status_id: localReferences.dealStatuses.contactEstablished,
    office_id: null,
    responsible_user_id: null,
    contact_id: null,
    address: '',
    coordinates: null,
    title: '',
    contract_number: '',
    contract_date: null,
    budget: '',
    link_id: 3,
    volume: '',
    square_m2: '',
    finish: false,
    jalousie: false,
    profile_type_id: null,
    promising_customer: false,
    measurement_date: null,
    measurement_time: null,
    to_production: false,
    measurer_user_id: null,
    difficult_metering: false,
    measurer_bonus: '',
    conclusion_id: null,
    start_production_date: null,
    discount: '',
    prepay: '',
    prepay_actual: '',
    delivery_income_amount: null,
    install_income_amount: null,
    pay_type_id: null,
    installer_balance: '',
    in_production_id: null,
    production_cost: '',
    jalousie_cost: '',
    finish_cost: '',
    garbage_removal_id: null,
    contractor_id: null,
    delivery_date: null,
    installation_date: null,
    installation_user_id: null,
    installers_salary: '',
    installers_debt: '',
    delivery_payment_plan: '',
    delivery_balance: '',
    additional_work: '',
    installation_done: false,
    complaint_opening_date: null,
    complaint_amount: '',
    guilty_id: null,
    penalty_fine: '',
    complaint_performer_id: null,
    complaint_performer_type: null,
    culprit_id: null,
    complaint_materials_cost: null,
    specialist_payment: '',
    complaint_closing_date: null,
    roistat: '',
    has_roistat: false,
    promising_customer_comment: null,
    refuse_before_metering: false,
    tech_refusal: false,
    re_measurement: false,
    re_measurement_date: null,
    re_measurement_time: null,
    actual_measurement_date: null,
    actual_measurement_time: null,
    contract_comment: null,
    finish_amount: '',
    jalousie_amount: '',
    complaint_comment: '',
    status: {},
    link: {},
    profile_type: {},
    measurer_user: {},
    conclusion: {},
    pay_type: {},
    in_production: {},
    garbage_removal: {},
    contractor: {},
    installation_user: {},
    guilty: {},
    complaint_performer: {},
    culprit: {},
    installation_photo: [],
    installation_act_photo: [],
    complaint_photo: [],
    place_photo: [],
    measure_photo: [],
    object_photo: [],
    act_photo: [],
    responsible_user: {
        office: {},
        date_fired: null
    },
    contact: {
        name: null,
        phone: null,
        email: null,
        comment: null,
        contact_phones: [
            {
                id: null,
                contact_id: null,
                phone: null,
                is_main: null
            }
        ]
    },
    tags: [],
    tag_ids: [],
    is_production_paid: false,
    refuse_reason_id: null,
    reason_comment: null
};

const photoFields = [
    'installation_photo',
    'complaint_photo',
    'place_photo',
    'measure_photo',
    'object_photo',
    'act_photo',
    'installation_act_photo'
];

const excludedFields = [
    'status',
    'responsible_user',
    'link',
    'profile_type',
    'measurer_user',
    'conclusion',
    'pay_type',
    'garbage_removal',
    'installation_user',
    'guilty',
    'in_production',
    'complaint_performer',
    'culprit',
    'contractor'
];

function prepareFormData(deal, isUpdate = false) {
    const formData = new FormData();
    Array.from(Object.keys(deal)).forEach(field => {
        if (excludedFields.indexOf(field) === -1) {
            formData.append(field, deal[field]);
        }
    });
    photoFields.forEach(field => {
        formData.set(field, JSON.stringify(deal[field]));
        deal[field].forEach(photo => {
            if (photo.raw) {
                formData.append([field] + photo.uid, photo.raw, photo.raw.name);
            }
        });
    });
    if (isUpdate) {
        formData.append('_method', 'PUT');
    }
    return formData;
}

const store = {
    namespaced: true,
    state() {
        return {
            deals: [],
            pages: {},
            current: { ...initialCurrentDeal },
            errors: {}
        };
    },

    mutations: {
        setDeals(state, data) {
            state.deals = data;
        },
        setPages(state, data) {
            state.pages = data;
        },
        setCurrent(state, data) {
            state.current = data;
            const tagIds = data.tags.length ? data.tags.map(tag => tag.pivot.tag_id) : [];
            Vue.set(state.current, 'tag_ids', tagIds);

            const refuseReasonId = data.refuse_reason ? data.refuse_reason.reason_id : null;
            const refuseReasonComment = data.refuse_reason ? data.refuse_reason.comment : null;

            Vue.set(state.current, 'refuse_reason_id', refuseReasonId);
            Vue.set(state.current, 'reason_comment', refuseReasonComment);
        },
        setErrors(state, data) {
            state.errors = data;
        },
        setCurrentField(state, { field, value }) {
            if (Array.isArray(value)) {
                Vue.set(state.current, field, [...value]);
            } else {
                Vue.set(state.current, field, value);
            }
            if (state.errors[[field]]) {
                delete state.errors[field];
            }
            if (field === 'measurement_date' && !state.current.re_measurement) {
                state.current.actual_measurement_date = state.current.measurement_date;
            }
            if (field === 're_measurement_date' && state.current.re_measurement) {
                state.current.actual_measurement_date = state.current.re_measurement_date;
            }
            if (field === 'measurement_time' && !state.current.re_measurement) {
                state.current.actual_measurement_time = state.current.measurement_time;
            }
            if (field === 're_measurement_time' && state.current.re_measurement) {
                state.current.actual_measurement_time = state.current.re_measurement_time;
            }
            if (field === 're_measurement') {
                if (value) {
                    state.current.actual_measurement_date = state.current.re_measurement_date;
                    state.current.actual_measurement_time = state.current.re_measurement_time;
                } else {
                    state.current.actual_measurement_date = state.current.measurement_date;
                    state.current.actual_measurement_time = state.current.measurement_time;
                }
            }
            if (field === 'installers_salary') {
                const installerBalance = Number.isInteger(state.current.installer_balance) ? state.current.installer_balance : 0;
                const installerSalary = Number.isInteger(state.current.installers_salary) ? state.current.installers_salary : 0;
                const installerSalaryPaid = Number.isInteger(state.current.installers_salary_paid) ? state.current.installers_salary_paid : 0;
                Vue.set(state.current, 'installers_debt', installerBalance - (installerSalary - installerSalaryPaid));
            }
            if (field === 'delivery_payment_plan' || field === 'budget') {
                const deliveryPaymentPlan = Number.isInteger(state.current.delivery_payment_plan) ? state.current.delivery_payment_plan : 0;
                const budget = Number.isInteger(state.current.budget) ? state.current.budget : 0;
                let deliveryBalance = 0;
                let installerBalance = 0;
                if (budget > 0) {
                    const incomePrepaymentAmount = Number.isInteger(state.current.prepay_actual) ? state.current.prepay_actual : 0;
                    const incomeDeliveryAmount = Number.isInteger(state.current.delivery_income_amount) ? state.current.delivery_income_amount : 0;
                    const incomeInstallAmount = Number.isInteger(state.current.install_income_amount) ? state.current.install_income_amount : 0;
                    deliveryBalance = deliveryPaymentPlan - incomeDeliveryAmount;
                    installerBalance = budget - incomePrepaymentAmount - deliveryPaymentPlan - incomeInstallAmount;
                }
                Vue.set(state.current, 'delivery_balance', deliveryBalance);
                Vue.set(state.current, 'installer_balance', installerBalance);

                const installerSalary = Number.isInteger(state.current.installers_salary) ? state.current.installers_salary : 0;
                const installerSalaryPaid = Number.isInteger(state.current.installers_salary_paid) ? state.current.installers_salary_paid : 0;
                Vue.set(state.current, 'installers_debt', installerBalance - (installerSalary - installerSalaryPaid));
            }
        },
        clearStore(state) {
            state.deals = {};
            state.current = {};
            state.pages = {};
        },
        clearCurrent(state) {
            state.current = { ...initialCurrentDeal };
        },
        clearErrors(state) {
            state.errors = [];
        }
    },
    actions: {
        getPaginatedList({ state, commit }, params) {
            return new Promise((resolve, reject) => {
                api.get('/deal/?' + qs.stringify(params)).then(response => {
                    commit('setDeals', response.data.data);
                    commit('setPages', response.data.meta);
                    resolve(response);
                }).catch(
                    error => {
                        reject(error);
                    });
            });
        },
        async getDeal({ state, commit }, dealId) {
            if (dealId !== 0) {
                try {
                    const response = await api.get('/deal/' + dealId);
                    commit('setCurrent', response.data.data);
                    commit('clearErrors');
                } catch (e) {
                    throw new Error('Произошла ошибка: ' + e.response.data.error);
                }
            }
        },
        async getDealById({ state, commit }, dealId) {
            try {
                const response = await api.get('/deal/' + dealId);
                return response.data.data;
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            }
        },
        async updateDeal({ state, commit }) {
            commit('clearErrors');
            try {
                api.defaults.headers['Content-Type'] = 'multipart/form-data';
                const formData = prepareFormData(state.current, true);
                const response = await api.post('/deal/' + state.current.id, formData);
                commit('setCurrent', response.data.data);
            } catch (e) {
                let message = 'Произошла ошибка: ';
                if (e.response) {
                    if (e.response.status === 422) {
                        const errorsList = Object.keys(e.response.data.errors).map(item => e.response.data.errors[item][0]);
                        commit('setErrors', e.response.data.errors);
                        message += 'неправильно заполнены поля: <br>• ' + errorsList.join('<br>• ');
                    } else {
                        message += e.response.data.error;
                    }
                }
                throw new Error(message);
            } finally {
                api.defaults.headers['Content-Type'] = 'application/json';
            }
        },
        async createDeal({ state, commit }) {
            commit('clearErrors');
            try {
                api.defaults.headers['Content-Type'] = 'multipart/form-data';
                const formData = prepareFormData(state.current);
                const response = await api.post('/deal/', formData);
                commit('setCurrent', response.data.data);
            } catch (e) {
                let message = 'Произошла ошибка: ';
                if (e.response) {
                    if (e.response.status === 422) {
                        const errorsList = Object.keys(e.response.data.errors).map(item => e.response.data.errors[item][0]);
                        commit('setErrors', e.response.data.errors);
                        message += 'неправильно заполнены поля: <br>• ' + errorsList.join('<br>• ');
                    } else {
                        message += e.response.data.error;
                    }
                }
                throw new Error(message);
            } finally {
                api.defaults.headers['Content-Type'] = 'application/json';
            }
        },
        async getPhoto({ state, commit }, params) {
            try {
                api.defaults.responseType = 'blob';
                return await api.get(`/deal/photo/${params.block}/${params.id}`);
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            } finally {
                api.defaults.responseType = '';
            }
        },
        async getMeasurersList({ state, commit }, date) {
            try {
                const response = await api.get(`/employer/measurer/${date}/`);
                return response.data.data;
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            }
        },
        async getDealsExportedToExcel({ state, commit }, params) {
            try {
                api.defaults.responseType = 'blob';
                return await api.get(`/deal/export/?${qs.stringify(params)}`);
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            } finally {
                api.defaults.responseType = '';
            }
        },
        async getInstallationCountByDate({ state, commit }, params) {
            try {
                const response = await api.post('/deals/installation-count/', params);
                return response.data.data;
            } catch (e) {
                throw new Error(e);
            }
        }
    }
};

export default store;
